/**
 * @file   点赞收藏
 * @create macaiqi 2021/12/07
 * @update
 */
import React, { useEffect, useState, useCallback } from 'react';
import { isFavorite, ApiAddFavorite, apiDelCollection } from '../../../shared/api'
import { openLoginModal } from '../../common/LoginModal/store';
import { useDispatch } from 'react-redux';
import { message } from 'antd';
import cls from 'classnames'
import './index.scss'
import ShareModal from '../../common/ShareModal';
// 点赞 收藏
// operationType: 1，知识百科；2：影像探索；3：关系路径
// instanceId: 实例id conceptCode:实例概念标识
// fileInfoId: 影像探索传入的文件id
// startNodeName、endNodeName、active、list: 关系路径：起始节点名称、指向节点名称、选中路径索引、图谱数据
const Star = ({ operationType,instanceId,fileInfoId,startNodeName,endNodeName,active,list }) => {
  const token = localStorage.getItem('TOKEN');
  // const [token, settoken] = useState(localStorage.getItem('TOKEN'))
  const dispatch = useDispatch();
  const handleOpenLoginModal = () => {
    dispatch(openLoginModal());
  };
  const [ismark, setIsmark] = useState()   // 是否收藏
  const [markid, setMarkid] = useState()   // 已收藏，关联关系id
  const [markcount, setMarkcount] = useState()  // 收藏数量

  const [isstar, setIsstar] = useState()   // 是否点赞
  const [starid, setStarid] = useState()        // 已点赞，关联关系id
  const [starcount, setStarcount] = useState()  // 点赞数量

  const [open, setOpen] = useState(false);      // 是否展示分享弹框
  const [currentTime, setCurrentTime] = useState();  // 时间刷新器，用于触发打开分享弹框
  
  const Mark = useCallback(
    (type) => {
      // 查询是否被点赞/收藏，以及点赞收藏的数量
      isFavorite({
        type: type,                   // 0收藏 1点赞
        instanceId: instanceId,
        fileInfoId: fileInfoId,
        startNodeName: startNodeName,
        endNodeName: endNodeName
      }).then(res => {
        // !res.relationId 为 true,表示未收藏/未点赞；
        if (!res.relationId) {
          if (type === 0) {
            setIsmark(false)
            setMarkcount(res?.num)
          }
          if (type === 1) {
            setIsstar(false)
            setStarcount(res?.num)
          }
        } 
        // 已收藏/已点赞；
        else {
          if (type === 0) {
            setIsmark(true)
            setMarkcount(res?.num)
            setMarkid(res.relationId)
          }
          if (type === 1) {
            setIsstar(true)
            setStarcount(res?.num)
            setStarid(res.relationId)
          }
        }
      })
    },
    [instanceId,fileInfoId,startNodeName,endNodeName]
  )

  // 进入时判断是否收藏点赞
  useEffect(() => {
    // if (token) {
    Mark(0);
    Mark(1)
    // }
  }, [token, Mark])

  // 进行点赞、收藏、分享功能
  const addfavorite = (type) => {
    // 判断是否登录
    if (!localStorage.getItem('TOKEN')) {
      // message.error('请登录');
      handleOpenLoginModal();
      return false;
    }
    const addParams = {
      type: type,                   // 0收藏 1点赞
      instanceId: instanceId,
      fileInfoId: fileInfoId,
      startNodeName: startNodeName,
      endNodeName: endNodeName
    }
    // 收藏功能
    if (type === 0) {
      if (ismark) {
        // 如果已经收藏，就取消收藏
        apiDelCollection(markid).then(res => {
          if (res) {
            setIsmark(false)
            setMarkcount((markcount - 1))
            message.success('取消收藏成功')
          } else {
            message.error('取消收藏失败')
          }
        })
      } else {
        ApiAddFavorite(addParams).then(res => {
          if (res) {
            setIsmark(true)
            setMarkcount((markcount + 1))
            Mark(0)
            message.success('收藏成功')
          } else {
            message.error('收藏失败')

          }
        })
      }
    }
    // 点赞功能
    if (type === 1) {
      if (isstar) {
        // 如果已经点赞，就取消点赞
        apiDelCollection(starid).then(res => {
          if (res) {
            setIsstar(false)
            setStarcount((starcount - 1))
            message.success('取消点赞成功')
          } else {
            message.error('取消点赞失败')
          }
        })
      } else {
        ApiAddFavorite(addParams).then(res => {
          if (res) {
            setIsstar(true)
            setStarcount((starcount + 1))
            Mark(1)
            message.success('点赞成功')
          } else {
            message.error('点赞失败')
          }
        })
      }
    }
    // 分享功能
    if (type === 2){
      if(operationType == 3 && !active && active !== 0){
        message.info('请先选择一条关系路径！');
        return;
      }else{
        setOpen(true);
        setCurrentTime(new Date().getTime());
      }
    }
  }
  return (
    <div className='favorite'>
      <span onClick={(e) => { e.stopPropagation();addfavorite(0); }}>
        <i className={cls('operationIcon iconfont icon-shoucang', { 'active': ismark })} />
        <i className='count'>{markcount || 0}</i>
      </span>
      <span onClick={(e) => { e.stopPropagation();addfavorite(1); }}>
        <i className={cls('operationIcon iconfont icon-good', { 'active': isstar })} />
        <i className='count'>{starcount || 0}</i>
      </span>
      <span>
      <svg onClick={(e) => { e.stopPropagation();addfavorite(2); }} t="1667786587368" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2721" width="40" height="40"><path d="M380.36396 566.298587l300.553318 205.558677a149.295574 149.295574 0 1 1-38.731537 76.865893L338.262608 640.818406a149.295574 149.295574 0 1 1-13.180667-226.374746l318.938002-230.299087a149.295574 149.295574 0 1 1 43.082437 74.093261L375.501189 483.418215a149.039639 149.039639 0 0 1 4.905426 82.923028zM789.263209 213.406506a63.983817 63.983817 0 1 0 0-127.967635 63.983817 63.983817 0 0 0 0 127.967635z m0 725.149931a63.983817 63.983817 0 1 0 0-127.967635 63.983817 63.983817 0 0 0 0 127.967635z m-554.526418-341.247027a63.983817 63.983817 0 1 0 0-127.967634 63.983817 63.983817 0 0 0 0 127.967634z" fill="#3D3D3D" p-id="2722"/></svg>
      </span>
      <ShareModal visible={open} time={currentTime} operationType={operationType} instanceId={instanceId} fileInfoId={fileInfoId} startNodeName={startNodeName} endNodeName={endNodeName} active={active} list={list}/> 
    </div>
  )
}
export default Star;
